import React, { Component } from "react";
import service from "../../core/service";
import { toast } from "react-toastify";
import * as yup from "yup";
import { AppConstants } from "../../core/constants";

interface IProps { }

interface IState {
  policyHolderOtp: any;
  insuredOtp: any;
  insuredIdCard: any[];
  policyHolderIdCard: any[];
  guardianLetter: any[];
  SignedForm: any[];
  limitaionData: any[];
  insured_phon_number: string;
  policy_holder_phon_number: string;
  policyHolderOtpLoading: boolean;
  insuredOtpLoading: boolean;
  policyHolderOtpDisabled: boolean;
  insuredOtpDisabled: boolean;
  policyHolderErrors:any;
  insuredErrors:any;
  fileErrors:any;
  loading:boolean;
  clicked:boolean;
  policyHolderOtpTimer: number;
  insuredOtpTimer: number;
  policyHolderOtpFormatted: any,
  insuredOtpFormatted: any,
  draftOfferLoading:boolean,
  uploadedFiles: {
    [key: string]: any[]; // برای ذخیره فایل‌های مختلف
  };
}

export class ProcessCompleteController extends Component<IProps, IState> {
  arrowRef: any;
  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.arrowRef = React.createRef();
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    policyHolderOtp: "",
    insuredOtp: "",
    insuredIdCard: [],
    policyHolderIdCard: [],
    guardianLetter: [],
    SignedForm: [],
    limitaionData: [],
    insured_phon_number: "",
    policy_holder_phon_number: "",
    policyHolderOtpLoading: false,
    insuredOtpLoading: false,
    policyHolderOtpDisabled: true,
    insuredOtpDisabled: true,
  loading:false,
    uploadedFiles: {
      insuredIdCard: [],
      policyHolderIdCard: [],
      guardianLetter: [],
      SignedForm: [],
    },
  policyHolderErrors:[],
  insuredErrors:[],
  fileErrors:[],
  clicked: false,
  policyHolderOtpTimer: 0,
  insuredOtpTimer: 0,
  policyHolderOtpFormatted: "0:00",
  insuredOtpFormatted: "0:00",
  draftOfferLoading:false,
  };

  handleFileUpload = (file: File, type: string) => {
    if (!file) {
      return;
    }
  
    // Check for SVG files
    if (file.type === "image/svg+xml") {
      toast.error("آپلود فایل SVG مجاز نمی‌باشد");
      return;
    }
  
    // Check for zero-size files
    if (file.size === 0) {
      toast.error("آپلود فایل با حجم صفر مجاز نمی‌باشد.");
      return;
    }
  
    // Check for file size limit (1 MB)
    if (file.size > 1 * 1024 * 1024) {
      toast.error("حجم فایل نباید بیشتر از 1 مگابایت باشد");
      return;
    }
  
    const reader = new FileReader();
    reader.onloadend = () => {
      const preview = reader.result;
      this.setState((prevState) => {
        const existingFiles = Array.isArray(prevState.uploadedFiles[type])
          ? prevState.uploadedFiles[type]
          : [];
        return {
          uploadedFiles: {
            ...prevState.uploadedFiles,
            [type]: [...existingFiles, { preview, file }],
          },
        };
      });
    };
    reader.readAsDataURL(file);
    this.uploadFile(file, type);
  };

  handleRemoveFile = (type: string, index: number) => {
    this.setState((prevState) => {
      const existingFiles = Array.isArray(prevState.uploadedFiles[type])
        ? prevState.uploadedFiles[type]
        : [];
      existingFiles.splice(index, 1); // حذف فایل از آرایه
      return {
        uploadedFiles: {
          ...prevState.uploadedFiles,
          [type]: existingFiles,
        },
      };
    });
  };
  
  getLimitation = async () => {
    this.setState({ loading: true });
  
    try {
      const response = await service.limitationInquiry.attachmentDefault(
        window.location.pathname.split("/")[2],
        "UniversalHousing"
      );
  
      if (response) {
        const limitationData = response.data.data?.data || [];
  
        const fileTypes = [
          "insuredIdCard",
          "policyHolderIdCard",
          "guardianLetter",
          "SignedForm"
        ];
  
        fileTypes.forEach((type) => {
          const item = limitationData.find((i: any) => i.name === type);
          if (item?.default) {
            const preview = `${AppConstants.base_core_url}${item?.default?.file}`;
            const file = null;
  
            this.setState((prevState: any) => ({
              uploadedFiles: {
                ...prevState.uploadedFiles,
                [type]: [{ preview, file }], // فقط یک مقدار — آرایه تک‌عضوی
              },
            }));
          }
        });
  
        this.setState({
          limitaionData: limitationData,
          loading: false,
        });
      }
    } catch (error: any) {
      this.setState({ loading: false });
      if (error?.status === 400) {
        toast.error("قرارداد یافت نشد");
      }
    }
  };
  
  async uploadFile(file: File, type: string) {
    const { uploadedFiles } = this.state;
    const shebaCodeSchema = yup.object({
      // fileUpload: yup.string().required("فایل اجباری می باشد"),
      // descr: yup.string().required("توضیحات اجباری می باشد"),

    });
    // this.setState({ uploadLoading: true })
    try {
      await shebaCodeSchema.validate({ uploadedFiles }, { abortEarly: false });

      const response = await service.limitationInquiry.uploadUniversalOffer(
        // "Universal",
        {
          attachments: file,
          policy_id: window.location.pathname.split("/")[2],
          file_type: type.toString()
        }
      );
      if (response) {
        toast.success(response?.data?.message);
      }

    } catch (err: any) {
      this.setState({
      });
    }
  }

  async getOtp(phoneNumber: string, isPolicy: boolean) {
    // const { price } = this.state;

    if (isPolicy) {
      this.setState({ policyHolderOtpLoading: true })
    } else {
      this.setState({ insuredOtpLoading: true })
    }
    const shebaCodeSchema = yup.object({
      // price: yup.string().required("مبلغ اجباری می باشد") .test("email-include-domain", "مبلغ پرداختی نمیتواند کمتر از 1 ریال و بیشتر از 2000000000 ریال باشد  ",
      //   (value) => {
      //   if (Number(value) < 1  || Number(value) > 2000000000) {
      //                return false;
      //            }else{
      //              return true
      //            }

      //          })

    });
    try {
      await shebaCodeSchema.validate({}, { abortEarly: false });

      const response = await service.limitationInquiry.universalOfferOtp({
        policy_id: window.location.pathname.split("/")[2],
        phone_number: phoneNumber
      });
      if (response) {
        toast.success(response?.message);
        if (isPolicy) {
          this.setState({ policyHolderOtpLoading: false, policyHolderOtp: "", policyHolderOtpDisabled: false })
        } else {
          this.setState({ insuredOtpLoading: false, insuredOtp: "", insuredOtpDisabled: false })
        }
        //  window.location.href = response?.data?.data?.data?.url
      }
    } catch (err: any) {
      // this.setState({ error: err.inner })
    }
  };


  async verifyPolicyHolderOtp(phoneNumber: string) {
    // this.setState({ errors: [], policyHolderOtpLoading: true });
    this.setState({  policyHolderOtpLoading: true });

    const { limitaionData, policyHolderOtp } = this.state;
  
    const shebaCodeSchema = yup.object({
      policyHolderOtp: 
  (
    limitaionData.find(item => item.name === "insuredEqualPolicyHolder")?.default === true 
    || limitaionData.find(item => item.name === "insuredEqualPolicyHolder")?.default === false
  )
  && limitaionData.find(item => item.name === "verify_policy_holder_phon_number")?.default !== true
        ? yup.string().required("کد تایید بیمه‌گذار اجباری است")
        : yup.string(),
    });
  
    try {
      await shebaCodeSchema.validate({ policyHolderOtp }, { abortEarly: false });
      const response = await service.limitationInquiry.universalOfferOtpVerify({
        policy_id: window.location.pathname.split("/")[2],
        otp_code: policyHolderOtp,
        phone_number: phoneNumber,
      });
  
      if (response) {
        await this.getLimitation();
        this.setState({
          policyHolderOtpLoading: false,
          policyHolderOtpDisabled: true,
          policyHolderErrors: [],
        });
        toast.success(response?.data?.data?.message);
      }
    } catch (err: any) {
      this.setState({ policyHolderOtpLoading: false });
      if (err?.status === 400) {
        toast.error(err?.data?.data?.message);
      } else {
        this.setState({ policyHolderErrors: err.inner });
      }
    }
  }
  async verifyInsuredOtp(phoneNumber: string) {
    // this.setState({ errors: [], insuredOtpLoading: true });
    this.setState({ insuredOtpLoading: true });
    const { limitaionData, insuredOtp } = this.state;
  
    const shebaCodeSchema = yup.object({
      insuredOtp: limitaionData.find((item: any) => item.name === "insuredEqualPolicyHolder")?.default === false
        ? yup.string().required("کد تایید بیمه شده اجباری است")
        : yup.string(),
    });
  
    try {
      await shebaCodeSchema.validate({ insuredOtp }, { abortEarly: false });
      const response = await service.limitationInquiry.universalOfferOtpVerify({
        policy_id: window.location.pathname.split("/")[2],
        otp_code: insuredOtp,
        phone_number: phoneNumber,
      });
  
      if (response) {
        await this.getLimitation();
        this.setState({
          insuredOtpLoading: false,
          insuredOtpDisabled: true,
          insuredErrors: [],
        });
        toast.success(response?.data?.data?.message);
      }
    } catch (err: any) {
      this.setState({ insuredOtpLoading: false });
      if (err?.status === 400) {
        toast.error(err?.data?.data?.message);
      } else {
        this.setState({ insuredErrors: err.inner });
      }
    }
  }
  async validateFilesOnly() {
    const { limitaionData, uploadedFiles } = this.state;
  
    const isFieldRequired = (type: string) => {
      const shahkarResults = limitaionData.find((item: any) => item.name === "shahkar_results")?.default === false;
      const relationWithPolicyHolder = limitaionData.find((item: any) => item.name === "relation_with_policy_holder")?.default;
      const insuredEqualPolicyHolder = limitaionData.find((item: any) => item.name === "insuredEqualPolicyHolder")?.default;
  
      if (type === "SignedForm") return shahkarResults;
      if (type === "guardianLetter") return relationWithPolicyHolder === true;
      if (type === "insuredIdCard") return insuredEqualPolicyHolder === false;
      if (type === "policyHolderIdCard") return true;
  
      return false;
    };
  
    const schema = yup.object(
      ["SignedForm", "guardianLetter", "insuredIdCard", "policyHolderIdCard"].reduce((acc: any, type) => {
        if (isFieldRequired(type)) {
          acc[type] = yup.array().min(1, `آپلود این فایل اجباری است`);
        }
        return acc;
      }, {})
    );
  
    try {
      await schema.validate(uploadedFiles, { abortEarly: false });
      this.setState({ fileErrors: [] });
      return true;
    } catch (err: any) {
      if (err?.inner) {
        const fileErrors = err.inner;
        this.setState({ fileErrors });
      }
      return false;
    }
  }
  
  // متد validate فقط OTP
  async validateOtpsOnly() {
    const { limitaionData, policyHolderOtp, insuredOtp } = this.state;
  
    const schema = yup.object({
      policyHolderOtp: 
  (
    limitaionData.find(item => item.name === "insuredEqualPolicyHolder")?.default === true 
    || limitaionData.find(item => item.name === "insuredEqualPolicyHolder")?.default === false
  )
  && limitaionData.find(item => item.name === "verify_policy_holder_phon_number")?.default !== true
        ? yup.string().required("کد تایید بیمه‌گذار اجباری است")
        : yup.string(),
      insuredOtp: limitaionData.find((item: any) => item.name === "insuredEqualPolicyHolder")?.default === false && limitaionData.find((item: any) => item.name === "verify_insured_phon_number")?.default !== true
        ? yup.string().required("کد تایید بیمه شده اجباری است")
        : yup.string(),
    });
  
    try {
      await schema.validate({ policyHolderOtp, insuredOtp }, { abortEarly: false });
      //this.setState({ errors: [] });
      return true;
    } catch (err: any) {
      if (err?.inner) {
        const errors = err.inner;
        toast.error(errors[0].message);
        // this.setState({ errors });
      }
      return false;
    }
  }
  
  // متد اصلی ارسال


  async universalDraftOffer() {
    this.setState({ draftOfferLoading: true });
    try {
      const response = await service.limitationInquiry.universalDraftOffer({
                policy_id: window.location.pathname.split("/")[2],

      });
  
       if (response?.status === 200) {
        toast.success("اطلاعات با موفقیت ارسال شد.");
        window.location.href = "/dashboard";
      } else {
        toast.error(response?.data?.data || "خطایی رخ داده است");
      this.setState({ draftOfferLoading: false });

      }
    } catch (err: any) {
      this.setState({ draftOfferLoading: false });
      if (err?.status === 400) {
        toast.error(err?.data?.data?.message);
      } else {
        this.setState({ insuredErrors: err.inner });
      }
    }
  }
 
  formatTime(seconds: number): string {
  const min = Math.floor(seconds / 60);
  const sec = seconds % 60;
  return `${min}:${sec < 10 ? "0" : ""}${sec}`;
}
startOtpTimer(isPolicyHolder: boolean) {
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  if (isPolicyHolder) {
    this.setState(
      { policyHolderOtpTimer: 120, policyHolderOtpDisabled: false },
      () => {
        const interval = setInterval(() => {
          this.setState((prevState) => {
            const newTime = prevState.policyHolderOtpTimer - 1;
            if (newTime <= 0) {
              clearInterval(interval);
              return {
                policyHolderOtpTimer: 0,
                policyHolderOtpFormatted: "0:00",
                policyHolderOtpDisabled: true,
                policyHolderOtp: "",
              };
            }
            return {
              policyHolderOtpTimer: newTime,
              policyHolderOtpFormatted: formatTime(newTime),
              policyHolderOtpDisabled: prevState.policyHolderOtpDisabled,
              policyHolderOtp: prevState.policyHolderOtp,
            };
          });
        }, 1000);
      }
    );
  } else {
    this.setState({ insuredOtpTimer: 120, insuredOtpDisabled: false }, () => {
      const interval = setInterval(() => {
        this.setState((prevState) => {
          const newTime = prevState.insuredOtpTimer - 1;
          if (newTime <= 0) {
            clearInterval(interval);
            return {
              insuredOtpTimer: 0,
              insuredOtpFormatted: "0:00",
              insuredOtpDisabled: true,
              insuredOtp: "",
            };
          }
          return {
            insuredOtpTimer: newTime,
            insuredOtpFormatted: formatTime(newTime),
            insuredOtpDisabled: prevState.insuredOtpDisabled,
            insuredOtp: prevState.insuredOtp,

          };
        });
      }, 1000);
    });
  }
}
  
  
}



export default ProcessCompleteController;
